/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { change, reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { LegalFormView } from './legal-form-view';
import { LEGAL_FORM_NAME } from '../../constants';
import {
	getLegalSearchValueSelector,
	getLegalsOptionsSelector,
	getLegalsSelector,
	getFormInitialValuesSelector,
	getIsLegalsOptionsLoadingSelector,
	getIsLegalInfoLoadingSelector,
} from '../../selectors';
import { getLegalsOptionsAction, setLegalSearchValueAction } from '../../actions';
import { validate } from '../../utils';

const LegalFormWrapper = ({
	legalsOptions,
	isLegalsLoading,
	legalsSearchValue,
	onSetLegalSearchValue,
	onGetLegalsOptions,
	legals,
	onFieldChange,
	isLegalInfoLoading,
}) => {
	const handleLegalSearchChange = ({ target: { value } }) => {
		onSetLegalSearchValue(value);
		onGetLegalsOptions();
	};

	const handleLegalChange = value => {
		const currentLegal = legals.find(({ data }) => data.inn === value);

		if (currentLegal) {
			onFieldChange(LEGAL_FORM_NAME, 'name', currentLegal.value);
			onFieldChange(LEGAL_FORM_NAME, 'inn', currentLegal.data?.inn);
			onFieldChange(LEGAL_FORM_NAME, 'ogrn', currentLegal.data?.ogrn);
			onFieldChange(LEGAL_FORM_NAME, 'address', currentLegal.data?.address?.value);
			onSetLegalSearchValue(currentLegal.value);
		}
	};

	return (
		<LegalFormView
			legalsOptions={legalsOptions}
			isLegalsLoading={isLegalsLoading}
			onLegalSearchChange={handleLegalSearchChange}
			onLegalChange={handleLegalChange}
			legalsSearchValue={legalsSearchValue}
			isLegalInfoLoading={isLegalInfoLoading}
		/>
	);
};

const withForm = reduxForm({
	form: LEGAL_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(LegalFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
	legals: getLegalsSelector(),
	legalsOptions: getLegalsOptionsSelector(),
	legalsSearchValue: getLegalSearchValueSelector(),
	isLegalsLoading: getIsLegalsOptionsLoadingSelector(),
	isLegalInfoLoading: getIsLegalInfoLoadingSelector(),
});

const mapDispatchToProps = {
	onSetLegalSearchValue: setLegalSearchValueAction,
	onGetLegalsOptions: getLegalsOptionsAction,
	onFieldChange: change,
};

const LegalForm = connect(mapStateToProps, mapDispatchToProps)(withForm);

LegalFormWrapper.propTypes = {
	legalsOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string,
			data: PropTypes.shape({
				title: PropTypes.string.isRequired,
				address: PropTypes.string.isRequired,
				deleted: PropTypes.bool,
			}),
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	onSetLegalSearchValue: PropTypes.func.isRequired,
	onGetLegalsOptions: PropTypes.func.isRequired,
	legalsSearchValue: PropTypes.string.isRequired,
	legals: PropTypes.array.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	isLegalInfoLoading: PropTypes.bool.isRequired,
};

export { LegalForm };
